import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, isRef as _isRef, createVNode as _createVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  key: 2,
  class: "text-center mt-4"
}

import {computed, getCurrentInstance, onMounted, ref} from 'vue';
import {ChatTabStore} from "~/chat/ts/store/ChatTab";
import ChatForm from "~/chat/vue/widget/form/ChatForm.vue";
import {
    CHAT_EVENT_CONTACTS_PROVIDED,
    FORM_TYPE_AFTER_CHAT_START,
    FORM_TYPE_BEFORE_CHAT_START,
    FORM_TYPE_QUESTION_CATEGORY,
    MESSAGE_HTML_PREFIX
} from "~/chat/ts/Constants";
import Dictionary from "~/ts/library/Dictionary";
import ChatApiRequest from "~/chat/ts/service/request/ChatApiRequest";
import {IChatFormNextStep} from "~/chat/vue/widget/form/Interface";
import {WidgetStore} from "~/chat/ts/store/Widget";
import ChatMessage from "~/chat/vue/widget/tabs/chat/ChatMessage.vue";
import MessageWrapper from "~/chat/ts/data/chat/MessageWrapper";
import {ConfigStore} from "~/chat/ts/store/Config";
import {ChatEventManagerInstance} from "~/chat/ts/ChatEventManager";
import ChatHistoryTitle from "~/chat/vue/widget/tabs/chat/ChatHistoryTitle.vue";
import {OperatorsStore} from "~/chat/ts/store/Operators";
import {__} from "~/ts/library/Translate";


const __default__ = {
    name: "CollectContacts"
}

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: {
    scrollToElement: { type: Function }
  },
  setup(__props: any) {

let props = __props;
let showCollectContactsLoad = ref(false);
let value = ref<Dictionary<any>>();
let instance = getCurrentInstance().proxy;

onMounted(() => {
    props.scrollToElement(instance.$el as HTMLElement);
});

let collectContacts = ChatTabStore.collectContacts;


let isContactsFormRequired = ChatTabStore.isContactsFormRequired;

function cancelCollectContacts(filled: boolean = false) {
    ChatTabStore.setContactsFormFilled(formType.value, filled);
    ChatEventManagerInstance.emit(CHAT_EVENT_CONTACTS_PROVIDED, filled);
}

let eula = computed(() => {
    return formType.value !== FORM_TYPE_QUESTION_CATEGORY;
});

let formType = ChatTabStore.askForContactsFormType;

let displayAllSteps = computed(() => {
    return ChatTabStore.dialogStartForm.value.collectContactsDisplayAllSteps;
});

let collectContactsTitle = computed(() => {
    let titles: Dictionary<string> = {
        [FORM_TYPE_QUESTION_CATEGORY]: ConfigStore.siteParams.value.params.leadGen.questionCategories.textBeforeForm,
        [FORM_TYPE_BEFORE_CHAT_START]: null,
        [FORM_TYPE_AFTER_CHAT_START]: ChatTabStore.dialogStartForm.value.afterStart.title,
        def: __('INTRODUCE_YOURSELF')
    };

    return titles.hasOwnProperty(formType.value) ? titles[formType.value] : titles.def;
});

let message = computed(() => {
    let message: MessageWrapper;
    if (formType.value == FORM_TYPE_BEFORE_CHAT_START) {
        let text = ChatTabStore.dialogStartForm.value.collectContactsBeforeStartMessage;
        if (text && text.length) {
            message = new MessageWrapper({
                text: MESSAGE_HTML_PREFIX + text,
                from: "",
                isHideOperator: true
            });
        }
    }
    return message;
});

async function onContactsCollected(values: Dictionary<any>) {
    showCollectContactsLoad.value = true;
    let group = OperatorsStore.selected.value.group;
    let result = await ChatApiRequest.make({
        method: "updateClientInfo",
        p: {
            values,
            formType: ChatTabStore.askForContactsFormType.value,
            operatorsGroupId: group ? group.id : null,
            isKeepOnline: ChatTabStore.askForContactsIsKeepOnline.value
        }
    });
    showCollectContactsLoad.value = true;

    if (result.isSuccess()) {
        cancelCollectContacts(true);
    } else {
        WidgetStore.showModalMessage({text: result.getDescr(), vue: instance});
    }
    showCollectContactsLoad.value = false;
}


function onCollectContactsNextStep(p: IChatFormNextStep) {
    if (p.lastInput) {
        props.scrollToElement(p.lastInput.$el as HTMLElement)
    }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    (_unref(collectContactsTitle))
      ? (_openBlock(), _createBlock(ChatHistoryTitle, { key: 0 }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(collectContactsTitle)), 1)
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (_unref(message))
      ? (_openBlock(), _createBlock(ChatMessage, {
          key: 1,
          message: _unref(message),
          "show-time": false,
          "show-date-if-needed": false,
          class: "mb-2"
        }, null, 8, ["message"]))
      : _createCommentVNode("", true),
    _createVNode(ChatForm, {
      modelValue: _unref(value),
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(value) ? (value).value = $event : value = $event)),
      "show-load": _unref(showCollectContactsLoad),
      form: _unref(collectContacts),
      step: "",
      "display-all-steps": _unref(displayAllSteps),
      eula: _unref(eula),
      onNextStep: onCollectContactsNextStep,
      onApply: onContactsCollected
    }, null, 8, ["modelValue", "show-load", "form", "display-all-steps", "eula"]),
    (!_unref(isContactsFormRequired))
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("a", {
            class: "link-dashed text-muted",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (cancelCollectContacts(false)))
          }, _toDisplayString(_unref(__)('CANCEL')), 1)
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})